import { useState } from 'react'

import { Grid } from '@material-ui/core'
import CustomButton from 'Components/UI/Atoms/CustomButton'
import PictureCard from 'Components/UI/Atoms/PictureCard'
import useCustomSnackbar from 'Components/UI/Atoms/SnackBar'
import { fileNameFromURL, shortenUrl, shortenUrlFiles } from 'Helpers'
import { interfaces } from 'service/interfaces'

import Delete from './Delete'
import { styles } from './styles'
import Upload from './Upload'

const File = (props) => {
  const { formEdit } = props
  const [change, setChange] = useState()
  const [dataActions, setDataActions] = useState({})
  const [isLoading, setIsLoading] = useState(false)

  const classes = styles()

  const createDismissableSnackbar = useCustomSnackbar()

  function handleOpenActions(openRemove, openUpload, data, position) {
    setDataActions({
      openRemove: openRemove,
      openUpload: openUpload,
      index: position,
      data: data,
      id: formEdit.id,
    })
  }
  function handleChange(e) {
    e.preventDefault()
    let img = e.target.files[0]
    setChange({
      ...change,
      file: img,
    })
  }
  function handleCloseActions() {
    setChange()
    setDataActions({
      openUpload: false,
      openRemove: false,
      id: null,
    })
  }
  function handleAdd(arr) {
    formEdit.documentacion?.push(arr)
  }
  function handleDeleteContext(index) {
    formEdit.documentacion?.splice(index, 1)
  }

  async function handleSubmitDelete(arr, index) {
    setIsLoading(true)
    const id = formEdit.id
    if (arr !== '' && arr !== undefined) {
      let filename = shortenUrl(formEdit.documentacion[index])
      await interfaces.wafersWithControlInterface
        .deleteFile('documentacion', id, formEdit.dominio, {
          filename,
        })
        .then((res) => {
          createDismissableSnackbar(res.data, {
            variant: 'success',
          })
          handleDeleteContext(index)
          handleCloseActions()
          setIsLoading(false)
        })
        .catch((error) => {
          createDismissableSnackbar(error.response.data.data, {
            variant: 'error',
          })
          handleCloseActions()
          setIsLoading(false)
        })
    } else {
      createDismissableSnackbar('Esta foto no existe! ', {
        variant: 'error',
      })
      handleCloseActions()
    }
  }

  async function handleSubmitUpload(value) {
    setIsLoading(true)
    await interfaces.wafersWithControlInterface
      .uploadFile(value, formEdit.id, formEdit.dominio, 'documentacion')
      .then((res) => {
        createDismissableSnackbar(`${res.data.msg}`, {
          variant: 'success',
        })
        handleAdd(res.data.url)
        handleCloseActions()
        setIsLoading(false)
      })
      .catch((error) => {
        createDismissableSnackbar(error.response.data.data, {
          variant: 'error',
        })
        handleCloseActions()
        setIsLoading(false)
      })
  }

  return (
    <div>
      <Grid container spacing={3} justify="center">
        {formEdit.documentacion?.map((item, index) => (
          <Grid item xs={12} xl={4} sm={6} md={4}>
            <PictureCard
              img={process.env.PUBLIC_URL + '/Images/file.png'}
              href={item}
              edit={true}
              txt={shortenUrlFiles(formEdit.documentacion[index])}
              longtxt={fileNameFromURL(formEdit.documentacion[index])}
              index={formEdit.documentacion?.index}
              handleDelete={() => handleOpenActions(true, false, item, index)}
            />
          </Grid>
        ))}
        <Grid item xs={12} xl={12} sm={12} md={12} className={classes.container}>
          <CustomButton
            onClick={() => handleOpenActions(false, true)}
            text="Agregar archivos"
            className={classes.cardSelectImg}
            size="small"
          />
        </Grid>
      </Grid>
      <Delete
        data={dataActions}
        open={dataActions.openRemove}
        handleClose={handleCloseActions}
        onSubmit={handleSubmitDelete}
        loading={isLoading}
      />
      <Upload
        handleChange={handleChange}
        change={change}
        data={dataActions}
        onSubmit={() => handleSubmitUpload(change.file)}
        handleClose={handleCloseActions}
        open={dataActions.openUpload}
        loading={isLoading}
      />
    </div>
  )
}

export default File
